import React from "react";
import { Building2, Truck } from "lucide-react";

const ChatTypeIcon = ({ type, size = 20 }) => {
  if (type === "driver") {
    return <Truck size={size} color="#155DFC" />;
  }
  return <Building2 size={size} color="#9810FA" />;
};

export default ChatTypeIcon;
